import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import appStore from "./redux/store";
import { Spin } from "antd";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./utils/i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MAINTENANCE_MODE } from "./utils/constants";
import MaintenanceMode from "./components/MaintenanceMode";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Check maintenance mode at the root level
if (MAINTENANCE_MODE.enabled) {
  root.render(
    <React.StrictMode>
      <MaintenanceMode />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <Provider store={appStore}>
        <HashRouter>
          <React.Suspense
            fallback={
              <div className="loading-div">
                <Spin size="large" />
              </div>
            }
          >   
              <App />
            <ToastContainer />
          </React.Suspense>
        </HashRouter>
      </Provider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
